import { css } from '@emotion/react';
import styled from '@emotion/styled';

import type { StyledFlexProps } from './types';

const gapMap: Record<string, string> = {
  none: '0',
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
};

const getGapValue = (gap: string | undefined): string => {
  const safeGap = gap ?? 'none';

  if (safeGap in gapMap) {
    return gapMap[safeGap as keyof typeof gapMap] ?? safeGap;
  }

  return safeGap;
};

export const StyledFlex = styled.div<StyledFlexProps>`
  display: ${({ $inline }) => ($inline ? 'inline-flex' : 'flex')};
  flex-direction: ${({ $direction = 'row' }) => $direction};
  flex-wrap: ${({ $wrap = 'nowrap' }) => $wrap};
  justify-content: ${({ $justify = 'flex-start' }) => $justify};
  align-items: ${({ $align = 'stretch' }) => $align};
  gap: ${({ $gap = 'none' }) => getGapValue($gap)};
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  height: ${({ $fullHeight }) => ($fullHeight ? '100%' : 'auto')};
  ${({ $maxWidth }) => $maxWidth && `max-width: ${$maxWidth};`}

  ${({ $gap }) =>
    $gap === 'none' &&
    css`
      gap: 0;
    `}
`;